<script>
  import { VCard } from 'vuetify/lib'

  export default {
    name: 'CardView',

    extends: VCard,
  }
</script>
